import { render, staticRenderFns, recyclableRender, components } from "./online_reporting.vue?vue&type=template&id=2ebde5c6&scoped=true&"
var renderjs
import script from "./online_reporting.vue?vue&type=script&lang=js&"
export * from "./online_reporting.vue?vue&type=script&lang=js&"
import style0 from "./online_reporting.vue?vue&type=style&index=0&lang=css&"
import style1 from "./online_reporting.vue?vue&type=style&index=1&id=2ebde5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebde5c6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/online_reporting/online_reporting.vue"
export default component.exports